/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { officeControllerAddUsers } from '../fn/registry-offices/office-controller-add-users';
import { OfficeControllerAddUsers$Params } from '../fn/registry-offices/office-controller-add-users';
import { officeControllerCreate } from '../fn/registry-offices/office-controller-create';
import { OfficeControllerCreate$Params } from '../fn/registry-offices/office-controller-create';
import { officeControllerCreateType } from '../fn/registry-offices/office-controller-create-type';
import { OfficeControllerCreateType$Params } from '../fn/registry-offices/office-controller-create-type';
import { officeControllerDelete } from '../fn/registry-offices/office-controller-delete';
import { OfficeControllerDelete$Params } from '../fn/registry-offices/office-controller-delete';
import { officeControllerDeleteTypes } from '../fn/registry-offices/office-controller-delete-types';
import { OfficeControllerDeleteTypes$Params } from '../fn/registry-offices/office-controller-delete-types';
import { officeControllerDissociaUser } from '../fn/registry-offices/office-controller-dissocia-user';
import { OfficeControllerDissociaUser$Params } from '../fn/registry-offices/office-controller-dissocia-user';
import { officeControllerGetAll } from '../fn/registry-offices/office-controller-get-all';
import { OfficeControllerGetAll$Params } from '../fn/registry-offices/office-controller-get-all';
import { officeControllerGetAllByRegistry } from '../fn/registry-offices/office-controller-get-all-by-registry';
import { OfficeControllerGetAllByRegistry$Params } from '../fn/registry-offices/office-controller-get-all-by-registry';
import { officeControllerGetOne } from '../fn/registry-offices/office-controller-get-one';
import { OfficeControllerGetOne$Params } from '../fn/registry-offices/office-controller-get-one';
import { officeControllerGetTypes } from '../fn/registry-offices/office-controller-get-types';
import { OfficeControllerGetTypes$Params } from '../fn/registry-offices/office-controller-get-types';
import { officeControllerRenameType } from '../fn/registry-offices/office-controller-rename-type';
import { OfficeControllerRenameType$Params } from '../fn/registry-offices/office-controller-rename-type';
import { officeControllerUpdate } from '../fn/registry-offices/office-controller-update';
import { OfficeControllerUpdate$Params } from '../fn/registry-offices/office-controller-update';
import { RegistryOfficeByRegistryResponse } from '../models/registry-office-by-registry-response';
import { RegistryOfficeItem } from '../models/registry-office-item';
import { RegistryOfficeResponse } from '../models/registry-office-response';
import { RegistryOfficeType } from '../models/registry-office-type';
import { RegistryOfficeTypesResponse } from '../models/registry-office-types-response';

@Injectable({ providedIn: 'root' })
export class RegistryOfficesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `officeControllerGetAll()` */
  static readonly OfficeControllerGetAllPath = '/registry/office/list';

  /**
   * Restituisce l'elenco di tutte le sedi.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerGetAll$Response(params: OfficeControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeResponse;
}>> {
    return officeControllerGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco di tutte le sedi.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerGetAll(params: OfficeControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryOfficeResponse;
}> {
    return this.officeControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeResponse;
}>): BaseResponse & {
'data'?: RegistryOfficeResponse;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerGetAllByRegistry()` */
  static readonly OfficeControllerGetAllByRegistryPath = '/registry/office/list-by-registry/warehouses';

  /**
   * Restituisce l'elenco di tutte le sedi per azienda.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerGetAllByRegistry()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerGetAllByRegistry$Response(params: OfficeControllerGetAllByRegistry$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeByRegistryResponse;
}>> {
    return officeControllerGetAllByRegistry(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco di tutte le sedi per azienda.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerGetAllByRegistry$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerGetAllByRegistry(params: OfficeControllerGetAllByRegistry$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryOfficeByRegistryResponse;
}> {
    return this.officeControllerGetAllByRegistry$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeByRegistryResponse;
}>): BaseResponse & {
'data'?: RegistryOfficeByRegistryResponse;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerGetTypes()` */
  static readonly OfficeControllerGetTypesPath = '/registry/office/types';

  /**
   * Restituisce i tipi di sedi.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerGetTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerGetTypes$Response(params?: OfficeControllerGetTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeTypesResponse;
}>> {
    return officeControllerGetTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce i tipi di sedi.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerGetTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerGetTypes(params?: OfficeControllerGetTypes$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryOfficeTypesResponse;
}> {
    return this.officeControllerGetTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeTypesResponse;
}>): BaseResponse & {
'data'?: RegistryOfficeTypesResponse;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerCreateType()` */
  static readonly OfficeControllerCreateTypePath = '/registry/office/types';

  /**
   * Crea un tipo di sede.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerCreateType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerCreateType$Response(params: OfficeControllerCreateType$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeType;
}>> {
    return officeControllerCreateType(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un tipo di sede.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerCreateType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerCreateType(params: OfficeControllerCreateType$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryOfficeType;
}> {
    return this.officeControllerCreateType$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeType;
}>): BaseResponse & {
'data'?: RegistryOfficeType;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerDeleteTypes()` */
  static readonly OfficeControllerDeleteTypesPath = '/registry/office/types/{idType}';

  /**
   * Elimina un tipo di sede.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerDeleteTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerDeleteTypes$Response(params: OfficeControllerDeleteTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeType;
}>> {
    return officeControllerDeleteTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina un tipo di sede.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerDeleteTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerDeleteTypes(params: OfficeControllerDeleteTypes$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryOfficeType;
}> {
    return this.officeControllerDeleteTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeType;
}>): BaseResponse & {
'data'?: RegistryOfficeType;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerRenameType()` */
  static readonly OfficeControllerRenameTypePath = '/registry/office/types/{idType}';

  /**
   * Modifica un tipo di sede.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerRenameType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerRenameType$Response(params: OfficeControllerRenameType$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeType;
}>> {
    return officeControllerRenameType(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica un tipo di sede.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerRenameType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerRenameType(params: OfficeControllerRenameType$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryOfficeType;
}> {
    return this.officeControllerRenameType$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeType;
}>): BaseResponse & {
'data'?: RegistryOfficeType;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerCreate()` */
  static readonly OfficeControllerCreatePath = '/registry/office';

  /**
   * Crea una sede per un contatto.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerCreate$Response(params: OfficeControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeItem;
}>> {
    return officeControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea una sede per un contatto.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerCreate(params: OfficeControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryOfficeItem;
}> {
    return this.officeControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeItem;
}>): BaseResponse & {
'data'?: RegistryOfficeItem;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerGetOne()` */
  static readonly OfficeControllerGetOnePath = '/registry/office/{idOffice}';

  /**
   * Restituisce una sede.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerGetOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerGetOne$Response(params: OfficeControllerGetOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeItem;
}>> {
    return officeControllerGetOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce una sede.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerGetOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerGetOne(params: OfficeControllerGetOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryOfficeItem;
}> {
    return this.officeControllerGetOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeItem;
}>): BaseResponse & {
'data'?: RegistryOfficeItem;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerDelete()` */
  static readonly OfficeControllerDeletePath = '/registry/office/{idOffice}';

  /**
   * Elimina una sede.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerDelete$Response(params: OfficeControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeItem;
}>> {
    return officeControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina una sede.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerDelete(params: OfficeControllerDelete$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryOfficeItem;
}> {
    return this.officeControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeItem;
}>): BaseResponse & {
'data'?: RegistryOfficeItem;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerUpdate()` */
  static readonly OfficeControllerUpdatePath = '/registry/office/{idOffice}';

  /**
   * Modifica una sede.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerUpdate$Response(params: OfficeControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeItem;
}>> {
    return officeControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica una sede.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerUpdate(params: OfficeControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryOfficeItem;
}> {
    return this.officeControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeItem;
}>): BaseResponse & {
'data'?: RegistryOfficeItem;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerAddUsers()` */
  static readonly OfficeControllerAddUsersPath = '/registry/office/{idOffice}/users';

  /**
   * Aggiunge un utente ad una sede.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerAddUsers()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerAddUsers$Response(params: OfficeControllerAddUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeItem;
}>> {
    return officeControllerAddUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * Aggiunge un utente ad una sede.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerAddUsers$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  officeControllerAddUsers(params: OfficeControllerAddUsers$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryOfficeItem;
}> {
    return this.officeControllerAddUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeItem;
}>): BaseResponse & {
'data'?: RegistryOfficeItem;
} => r.body)
    );
  }

  /** Path part for operation `officeControllerDissociaUser()` */
  static readonly OfficeControllerDissociaUserPath = '/registry/office/{idOffice}/user/{idUser}';

  /**
   * Dissocia un utente da un contatto.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `officeControllerDissociaUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerDissociaUser$Response(params: OfficeControllerDissociaUser$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeItem;
}>> {
    return officeControllerDissociaUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Dissocia un utente da un contatto.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `officeControllerDissociaUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  officeControllerDissociaUser(params: OfficeControllerDissociaUser$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: RegistryOfficeItem;
}> {
    return this.officeControllerDissociaUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeItem;
}>): BaseResponse & {
'data'?: RegistryOfficeItem;
} => r.body)
    );
  }

}
